import axios from 'axios'
import { apiEndPoints, apiMethods } from './apiConstants'
import customAxios from './customAxios'

export const logoutUserThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.signOut)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const updateUserPreferredLanguageThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.updatePreferredLanguage, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const getUserPreferredLanguageThunk = async () => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.getPreferredLanguage)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}
export const setDefaultAddressThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.setDefaultAddress, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const updateShippingAddressThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.updateShippingAddress, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const deleteShippingAddressThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.deleteShippingAddress, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const generatePresignedUrlThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.generatePresignedUrl, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const uploadImagesToS3Thunk = (presignedUrl, selectedImage, config) => async (dispatch) => {
	try {
		const res = await axios.put(presignedUrl, selectedImage, {
			// headers: {
			// 	'Content-Type': selectedImage.type, // Only Content-Type header is necessary
			// },
		})
		return res
	} catch (error) {
		console.error('Error uploading image to S3:', error)
		throw error
	}
}
